module.exports = __webpack_public_path__ + "static/media/Miami soffa 2-sits tyg siri grön 06 mölle bistro orwel miljö 2023 1.3f8fc6c9.jpg";